import { Button, Form, Input, message, Tabs } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { changePasswordApi } from '../api';
import { language } from '../language';
import './index.less';

const formItemLayout = { labelCol: { span: 6 }, wrapperCol: { span: 18 }, };
const tailFormItemLayout = { wrapperCol: { span: 24 }, };

const ChangePassword = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const $t = (key) => language.zh[key] || key;
  const [tabsId, setTabsId] = useState('1');

  const items = [{ label: $t('Change By Phone'), key: '1' }, { label: $t('Change By Email'), key: '2' }];

  const onFinish = async (values) => {
    const { data: { code, msg } } = await changePasswordApi(values);
    if (code === 0) {
      message.success(msg);
      history.push('/login');
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onTabsChange = (activeKey) => {
    setTabsId(activeKey);
    form.resetFields();
  };

  return (
    <div className='change-password-container'>
      <Tabs defaultActiveKey="1" onChange={onTabsChange} centered tabBarGutter={100} items={items} />
      <Form {...formItemLayout} form={form} name="changePassword" onFinish={onFinish} onFinishFailed={onFinishFailed} initialValues={{ prefixPhone: 3756 }} style={{ maxWidth: 600 }} scrollToFirstError className='change-password-form'>
        {
          tabsId === '1' ?
              <Form.Item label={$t('Phone Number')} name="account" rules={[{ pattern: /^1[0-9]{10}$/, message: $t('Incorrect Phone Number Format') }, { required: true, message: $t('Please Enter Phone Number') },]}><Input style={{ width: 'calc(100% - 130px)' }} placeholder={$t('Phone Number')} autoComplete="off" />
          </Form.Item> :
            <Form.Item name="email_account" label={$t('Please Enter Email Address')} rules={[{ type: 'email', message: $t('Incorrect Email Format') }, { required: true, message: $t('Please Enter Email Address') },]} >
              <Input placeholder={$t('Please Enter Email Address')} autoComplete="off" />
            </Form.Item>
        }
        <Form.Item name="password" label={$t('Current Password')} rules={[{ required: true, message: $t('Please Enter Current Password') }]} >
          <Input.Password placeholder={$t('Please Enter Current Password')} maxLength={16} autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          name="new_password"
          label={$t('New Password')}
          required
          rules={[{ min: 6, message: $t('Please Enter At Least 6 Characters') }, () => ({
            validator(_, value) {
              if (!value) {
                return Promise.reject($t('New Password'));
              }
              const invalidChars = [...new Set(value.replace(/[A-Za-z0-9!@#$_\-*]/g, ''))];
              if (invalidChars.length > 0) {
                return Promise.reject(new Error($t('Invalid character: ') + invalidChars.join(' ')));
              }
              if (!(/^[A-Za-z0-9!@#$_*-]{6,16}$/.test(value) && [/[a-z]/, /[A-Z]/, /\d/, /[!@#$_*-]/].filter(r => r.test(value)).length >= 3)) {
                return Promise.reject(new Error($t('6-16 characters, must include letter, digit, and special character')));
              }
              return Promise.resolve();
            },
          }),
          ]}
        >
          <Input.Password placeholder={$t('6-16 characters, must include letter, digit, and special character')} maxLength={16} autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="re_new_password"
          label={$t('Confirm Password')}
          required
          dependencies={['new_password']}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject($t('Confirm Password'));
                }
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error($t('Passwords Do Not Match')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={$t('Confirm Password')} maxLength={16} autoComplete="new-password" />
        </Form.Item>
        <Form.Item {...tailFormItemLayout} className='change-password-button'>
          <Button type="primary" htmlType="submit">
            {$t('Change Password')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;